export interface ToolStatus {
  type: 'running' | 'complete' | 'incomplete' | 'requires-action';
  reason?: string;
}

export function getToolStatusFlags(status?: ToolStatus) {
  return {
    isRunning: status?.type === 'running',
    isComplete: status?.type === 'complete',
    isError: status?.type === 'incomplete' && status?.reason === 'error',
  };
}

export interface ToolCallApproval {
  approved?: boolean;
  resolution?: string;
}

// Message-wide status conflates running, declined and queued siblings. Prefer each call's approval and result.
export function buildToolCallStatus({
  result,
  hasError,
  approval,
  isGated,
}: {
  result: unknown;
  hasError?: boolean;
  approval?: ToolCallApproval;
  isGated?: boolean;
}): ToolStatus {
  if (approval?.resolution) return { type: 'incomplete', reason: approval.resolution };
  if (result !== undefined)
    return buildToolStatusFromFlags({ isRunning: false, hasError: !!hasError });
  if (!approval) {
    return isGated ? { type: 'requires-action', reason: 'queued' } : { type: 'running' };
  }
  if (approval.approved === false) return { type: 'incomplete', reason: 'declined' };
  if (approval.approved === true) return { type: 'running' };
  return { type: 'requires-action' };
}

export function buildToolStatusFromFlags({
  isRunning,
  hasError,
}: {
  isRunning: boolean;
  hasError: boolean;
}): ToolStatus {
  if (isRunning) return { type: 'running' };
  if (hasError) return { type: 'incomplete', reason: 'error' };
  return { type: 'complete' };
}
